import React from 'react'

/* ── design tokens ───────────────────────────────────────────── */
export const T = {
  font: "'DM Sans', 'Outfit', -apple-system, BlinkMacSystemFont, sans-serif",
  ink: '#111827',
  inkMid: '#374151',
  inkSub: '#6b7280',
  inkLight: '#9ca3af',
  border: '#e5e7eb',
  borderLight: '#f3f4f6',
  bg: '#ffffff',
  surface: '#f9fafb',
  blue: '#2563eb',
  blueLight: '#eff6ff',
  blueBorder: '#bfdbfe',
  amber: '#b45309',
  amberLight: '#fffbeb',
  amberBorder: '#fde68a',
  green: '#16a34a',
  greenLight: '#f0fdf4',
  greenBorder: '#bbf7d0',
  red: '#dc2626',
  redLight: '#fef2f2',
  redBorder: '#fecaca',
  orange: '#ea580c',
  orangeLight: '#fff7ed',
  orangeBorder: '#fed7aa'
}

/* ── utils ───────────────────────────────────────────────────── */
export const fmtSec = s => {
  const sec = Number.parseFloat(s)
  if (!Number.isFinite(sec)) return '0.0s'
  if (sec < 60) return `${sec.toFixed(1)}s`
  return `${Math.floor(sec / 60)}:${(sec % 60).toFixed(1).padStart(4, '0')}`
}

export const fmtMs = ms => {
  const value = Number.parseFloat(ms)
  if (!Number.isFinite(value)) return '–'
  return `${(value / 1000).toFixed(1)}s`
}

export const speakerColor = speaker => {
  if (!speaker || speaker === 'narrator') return T.blue
  let h = 0
  for (let i = 0; i < speaker.length; i++)
    h = speaker.charCodeAt(i) + ((h << 5) - h)
  return ['#059669', '#d97706', '#7c3aed', '#db2777', '#0891b2'][
    Math.abs(h) % 5
  ]
}

export const speakerName = (speaker, map = {}) => {
  if (!speaker || speaker === 'narrator') return 'Narrator'
  const val = map[speaker]
  if (!val) return speaker
  return typeof val === 'object' ? val.name || val.character_id : val
}

/* ── micro helpers ───────────────────────────────────────────── */
export const Label = ({ children }) => (
  <div
    style={{
      fontSize: 11,
      fontWeight: 700,
      color: T.inkLight,
      textTransform: 'uppercase',
      letterSpacing: '0.6px',
      marginBottom: 10,
      display: 'flex',
      alignItems: 'center',
      gap: 6
    }}
  >
    {children}
  </div>
)

export const Hr = () => (
  <div style={{ height: 1, background: T.borderLight, margin: '4px 0 24px' }} />
)

export const Chip = ({ color, bg, border, children }) => (
  <span
    style={{
      fontSize: 11,
      fontWeight: 600,
      color,
      background: bg,
      border: `1px solid ${border}`,
      borderRadius: 20,
      padding: '2px 10px'
    }}
  >
    {children}
  </span>
)
